var classList = require('dom-classlist');
var gsap = require('gsap');
var pubsub = require('pubsub');
var serialize = require('form-serialize');

module.exports = function () { 
	var _header = document.querySelector('#main-header')
	,	btSearch = document.querySelectorAll('.icon-zoom.opener-btn')
	,	_body = document.querySelector('body')
	,	_searchForm = document.querySelector('.search-form')

	addHandlers()

	function addHandlers(){
		console.log(btSearch);
		Array.prototype.forEach.call(btSearch, function(bt){
			 console.log('ok'); 
			bt.addEventListener('click', clickSearch);
		});
		
		pubsub.on('search:close', function(){
			classList(_body).remove('search-opened')
		}) 
	}

	function clickSearch(e){
		console.log('okss');
		e.preventDefault()
		classList(_body).toggle('search-opened')
		//pubsub.emit('newsletter:close') 
	}

	function submitForm(){ 

	}

}